//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'DpFormLabel',
  props: {
    helpText: { type: String, default: null },
  },
};
